/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Search_ActionInputs */

const en_lg_search_action = /** @type {(inputs: Lg_Search_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn about message search`)
};

const id_lg_search_action = /** @type {(inputs: Lg_Search_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari pencarian pesan`)
};

/**
* | output |
* | --- |
* | "Learn about message search" |
*
* @param {Lg_Search_ActionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_search_action = /** @type {((inputs?: Lg_Search_ActionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Search_ActionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_search_action(inputs)
	return en_lg_search_action(inputs)
});